/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { json, redirect } from 'react-router-dom';
import Session from 'supertokens-web-js/recipe/session';

import {
  getUserEmail,
  getInvitationDetail,
} from '@fai/friendli-suite/features/routes/loaders/apis/user';
import type { RegisterInviteDetailResponse } from '@fai/friendli-suite/features/types/auth/model';
import { customJson } from '@fai/third-party/react-router-dom';

export const strictFetchInvitationDetails = async () => {
  const invitationDetails = await getInvitationDetail();

  if (!invitationDetails) {
    // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw customJson({ message: 'failed to get invitation detail' }, { status: 500 });
  }

  return json(invitationDetails, { status: 200 });
};

export const redirectIfLoggedInUserIsInvited = (redirectPath: string) => async () => {
  const loaderData = await strictFetchInvitationDetails();
  const invitationDetails = (await loaderData.json()) as RegisterInviteDetailResponse['data'];

  const inviteeEmail = invitationDetails?.inviteeEmail;

  if (await Session.doesSessionExist()) {
    const clientUserEmail = await getUserEmail();

    if (clientUserEmail === inviteeEmail) {
      return redirect(redirectPath);
    }
  }

  return json(invitationDetails, { status: 200 });
};
